var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('something-went-wrong')))]),_c('p',{staticClass:"error-message",attrs:{"id":"error-message"}},[_vm._v(_vm._s(_vm.$t(_vm.error)))])])}
var staticRenderFns = []

export { render, staticRenderFns }